import { useState } from "react";
import {
    Typography,
    TextField,
    Button,
    Container,
    useTheme,
    useMediaQuery,
    MenuItem,
    InputAdornment,
    OutlinedInput,
    Autocomplete,
    Select,
    FormControl,
    InputLabel,
    Grid,
    Paper,
    Box,
    FormGroup,
    List,
    ListItem,
    ListItemText,
    Popover,
    Menu,
    Tab,
    Tabs,
    Card,
    CardContent,
} from "@mui/material";
import LinearProgress, {
    linearProgressClasses,
} from "@mui/material/LinearProgress";
import { __fetching_data__ } from "../../../components/api";
import { useSelector, useDispatch } from "react-redux";

const TabPassword = ({ userDetail, colors, isMobile }) => {
    const [isEditPassword, setIsEditPassword] = useState(false);
    const [localUserDetail, setLocalUserDetail] = useState(userDetail);
    const [pwdQuality, setPwdQuality] = useState({
        label: "Very Weak",
        percent: 0,
        color: "#E90F10",
        match: "no"
    });
    const pwdQualityProps = {
        label: ["Very Weak", "Weak", "Fair", "Good", "Strong"],
        color: [
            "#E90F10", // Very Weak
            "#FFAC00", // Weak
            "#F3D917", // Fair
            "#9BC158", // Good
            "#02B504", // Strong
        ],
    };
    const getPasswordStrength = (password) => {
        const lengthRule = password.length >= 8;
        const containsUppercase = /[A-Z]/.test(password);
        const containsLowercase = /[a-z]/.test(password);
        const containsDigit = /\d/.test(password);
        const containsSpecialChar = /[$@#&!]+/.test(password);
        const score = [
            containsUppercase,
            containsLowercase,
            containsDigit,
            containsSpecialChar,
        ].filter(Boolean).length;
        const percentage = (score / 4) * 100;
        return {
            label: pwdQualityProps["label"][score],
            percent: percentage,
            color: pwdQualityProps["color"][score],
        };
    };
    const handleEditPassword = (e) => {
        const { name, value } = e.target;
        if (name == "edit_password") {
            setIsEditPassword(true);
        } else {
            setIsEditPassword(!isEditPassword);
        }
        if (name == "cancel_edit_password") {
            ["current_password", "new_password", "confirm_password"].forEach((name) =>
                setLocalUserDetail((prevData) => ({ ...prevData, [name]: "" }))
            );
        }
    };
    const handleChangeInput = (e) => {
        const { name, value } = e.target;
        setLocalUserDetail((prevData) => ({ ...prevData, [name]: value }));
    };
    const handlePasswordChange = (e) => {
        const { name, value } = e.target;
        setLocalUserDetail((prevData) => ({ ...prevData, [name]: value }));
        const passwordStrength = getPasswordStrength(value);
        if (name === 'new_password') {
            passwordStrength.match = 'Yes';
            setPwdQuality(passwordStrength);

        }
        if (name === 'new_password' && value === localUserDetail.confirm_password) {
            setPwdQuality((prevData) => ({ ...prevData, match: "yes" }));
        } else if (name === 'confirm_password' && value === localUserDetail.new_password) {
            setPwdQuality((prevData) => ({ ...prevData, match: "yes" }));
        } else {
            setPwdQuality((prevData) => ({ ...prevData, match: "no" }));
        }
    };
    const csrfToken = useSelector((state) => state.csrfToken);
    const base_api_url =
        process.env.NODE_ENV === "production"
            ? window.location.protocol === "https:"
                ? process.env.REACT_APP_API_HTTPS_URL
                : process.env.REACT_APP_API_HTTP_URL
            : "/application";


    const handleSavePassword = async (e) => {
        // const { name, value } = e.target;
        // console.log(localUserDetail);
        // console.log(pwdQuality);
        if (pwdQuality.match == "yes" && pwdQuality.percent > 50) {
            const data = {
                current_password: localUserDetail.current_password,
                new_password: localUserDetail.new_password,
                confirm_password: localUserDetail.confirm_password
            }
            // const url = `/application/changepassword`;

            const response = await __fetching_data__({
                url: `${base_api_url}/changepassword`,
                method: "PUT",
                headers: { "xsrf-token": csrfToken },
                body: JSON.stringify(data)
            })
            // console.log(response)
        } else {
            // console.log("Not Change")
        }

    };

    return (
        <Grid container justifyContent="center" alignItems="center">

            <Grid container justifyContent="center" alignItems="center" marginBottom={3}>
                <Grid item xs={6} md={9}>
                <Box 
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    sx={{
                        width: '100%', 
                        backgroundColor: '#202431',
                        padding: 3,
                    }}
                >
                        <Box display="flex" flexDirection="column">
                            <Typography variant="h2" marginBottom={4} marginTop={4}>Password</Typography>                                
                        </Box>
                    </Box>
                </Grid>
            </Grid>
            <Card
                sx={{
                    width: '100%',
                    height: '100vh',
                    display: 'flex',
                    justifyContent: 'center',
                    backgroundColor: '#2E3343',          
                }}
            >
                <CardContent sx={{ marginTop: 11, paddingY: 0, paddingX: 0 }}>
                                           
                   
                    <Grid container justifyContent="center" alignItems="center" marginBottom={4}>
                        <Grid item xs={6} md={12}>
                            <Box 
                                display="flex" 
                                alignItems="center"
                                justifyContent="center"
                            >
                                <TextField
                                    type="password"
                                    label="Current Password"
                                    name="current_password"
                                    margin="normal"
                                    value={localUserDetail?.current_password}
                                    onChange={handleChangeInput}
                                    size="small"
                                    variant="outlined"
                                    InputProps={{
                                        readOnly: !isEditPassword,
                                        sx: {
                                            fontSize: 20,
                                            width: 350,
                                            paddingLeft: '8px',
                                            backgroundColor: '#D9D9D9',
                                            borderRadius: 20,
                                            color: 'black',
                                            textAlign: 'right',
                                        }
                                    }}
                                    InputLabelProps={{
                                        shrink: true,
                                        sx: {
                                            fontSize: 20,
                                            top: '-12px',
                                            paddingLeft: 33,
                                        },
                                    }}
                                />
                            </Box>
                        </Grid>
                    </Grid>
                    {/** row ================================================================================================================================== */}
                    <Grid container justifyContent="center" alignItems="center" marginBottom={4}>
                        <Grid item xs={6} md={12}>
                            <Box 
                                display="flex" 
                                alignItems="center"
                                justifyContent="center"
                            >
                                <TextField
                                    type="password"
                                    label="Password"
                                    name="new_password"
                                    margin="normal"
                                    value={localUserDetail?.new_password}
                                    onChange={handlePasswordChange}
                                    size="small"
                                    variant="outlined"
                                    InputProps={{
                                        readOnly: !isEditPassword,
                                        sx: {
                                            fontSize: 20,
                                            width: 350,
                                            paddingLeft: '8px',
                                            backgroundColor: '#D9D9D9',
                                            borderRadius: 20,
                                            color: 'black',
                                        }
                                    }}
                                    InputLabelProps={{
                                        shrink: true,
                                        sx: {
                                            fontSize: 20,
                                            top: '-12px',
                                            paddingLeft: 41,
                                        },
                                    }}
                                />
                            </Box>
                        </Grid>

                        {isEditPassword && (
                            <Grid item xs={12} md={12}>
                                <Typography
                                    sx={{
                                        fontWeight: "bold",
                                        textAlign: "center",
                                        marginTop: 1
                                    }}
                                >
                                    Password strength:{" "}
                                    <Typography
                                        component="span"
                                        variant="h6"
                                        sx={{
                                            fontWeight: "bold",
                                            color: pwdQuality.color,
                                        }}
                                    >
                                        {pwdQuality.label}
                                    </Typography>
                                </Typography>
                            </Grid>
                        )}
                    </Grid>
                    {/** row ================================================================================================================================== */}

                    <Grid container justifyContent="center" alignItems="center" marginBottom={4}>
                        <Grid item xs={6} md={12}>
                            <Box 
                                display="flex" 
                                alignItems="center"
                                justifyContent="center"
                            >
                                <TextField
                                    type="password"
                                    label="Confirm Password"
                                    name="confirm_password"
                                    margin="normal"
                                    value={localUserDetail.confirm_password}
                                    onChange={handlePasswordChange}
                                    size="small"
                                    variant="outlined"
                                    InputProps={{
                                        readOnly: !isEditPassword,
                                        sx: {
                                            fontSize: 20,
                                            width: 350,
                                            paddingLeft: '8px',
                                            backgroundColor: '#D9D9D9',
                                            borderRadius: 20,
                                            color: 'black',
                                        }
                                    }}
                                    InputLabelProps={{
                                        shrink: true,
                                        sx: {
                                            fontSize: 20,
                                            top: '-12px',
                                            paddingLeft: 32,
                                        },
                                    }}
                                />
                            </Box>
                            {isEditPassword &&
                                localUserDetail.confirm_password &&
                                pwdQuality.match !== "yes" && (
                                    <Typography
                                        sx={{
                                            fontSize: "0.75rem",
                                            color: "#E70808",
                                            marginTop: "4px",
                                            textAlign: "center"
                                        }}
                                    >
                                        The password confirmation does not match.
                                    </Typography>
                                )}
                        </Grid>
                    </Grid>
                    {/** row ================================================================================================================================== */}
                    <Grid container justifyContent="center" alignItems="center">
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                margin: 8
                            }}
                        >
                            {!isEditPassword ? (
                                <Button
                                    name="edit_password"
                                    variant="contained"
                                    size={isMobile ? "small" : "medium"}
                                    sx={{
                                        fontWeight: 'bold',
                                        fontSize: isMobile ? '16px' : '20px',
                                        textTransform: "none",
                                        backgroundColor: 'transparent',
                                        borderRadius: 20,
                                        border: '2px solid #F7F7F7',
                                        padding: '7px 12px',
                                        margin: '10px',
                                        width: '250px',
                                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                        transition: 'all 0.3s ease-in-out',
                                        "&:hover": {
                                            border: '2px solid transparent',
                                            boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
                                            backgroundColor: '#F7F7F7',
                                        },
                                    }}
                                    onClick={(e) => handleEditPassword(e)}
                                >
                                    Change Password
                                </Button>
                            ) : (
                                <>
                                    <Button
                                        name="save"
                                        variant="contained"
                                        type="submit"
                                        size={isMobile ? "small" : "medium"}
                                        sx={{
                                            fontWeight: 'bold',
                                            fontSize: isMobile ? '16px' : '20px',
                                            textTransform: "none",
                                            backgroundColor: 'transparent',
                                            borderRadius: 20,
                                            border: '2px solid #F7F7F7',
                                            padding: '7px 12px',
                                            margin: '10px',
                                            width: '150px',
                                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                            transition: 'all 0.3s ease-in-out',
                                            "&:hover": {
                                                border: '2px solid transparent',
                                                boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
                                                backgroundColor: '#F7F7F7',
                                            },
                                        }}
                                        onClick={(e) => handleSavePassword(e)}
                                        disabled={localUserDetail.new_password !== localUserDetail.confirm_password}
                                    >
                                        Save
                                    </Button>
                                    <Button
                                        name="cancel_edit_password"
                                        variant="contained"
                                        size={isMobile ? "small" : "medium"}
                                        sx={{
                                            fontWeight: 'bold',
                                            fontSize: isMobile ? '16px' : '20px',
                                            textTransform: "none",
                                            backgroundColor: 'transparent',
                                            borderRadius: 20,
                                            border: '2px solid #F7F7F7',
                                            padding: '7px 12px',
                                            margin: '10px',
                                            width: '150px',
                                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                            transition: 'all 0.3s ease-in-out',
                                            "&:hover": {
                                                border: '2px solid transparent',
                                                boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
                                                backgroundColor: '#F7F7F7',
                                            },
                                        }}
                                        onClick={(e) => handleEditPassword(e)}
                                    >
                                        Cancel
                                    </Button>
                                </>
                            )}
                        </Box>
                    </Grid>

                </CardContent>
            </Card>
        </Grid>
    );
};

export default TabPassword;
